export default __webpack_public_path__ + "icehockey-live.png";